// extracted by mini-css-extract-plugin
export default {"title":"CustomerFamilyModal_title__O80zi"};